/* eslint-disable @typescript-eslint/no-explicit-any */
// src/components/customer-search/FilterShortcuts.tsx
import { Box, Chip, Grid, Tooltip } from "@mui/material";
import React, { useState } from "react";

import { AppDispatch } from "../../../store";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { applyPredefinedFilter } from "../../../store/slices/customerFilterSlice";
import { FilterDefinition, filterService } from "./FilterConfig";

interface FilterShortcutsProps {
  viewType?: "customer" | "prospect" | "custom";
  userId?: string;
}

const FilterShortcuts: React.FC<FilterShortcutsProps> = () => {
  const dispatch: AppDispatch = useAppDispatch();
  const { activePredefinedFilter } = useAppSelector(
    (state) => state.customerFilter
  );

  const [categories] = useState<FilterDefinition[]>(filterService.getFilters());

  // --- Handlers ---
  const handleApplyPredefined = (filter: any) => {
    dispatch(
      applyPredefinedFilter({ filterId: filter.id, filters: filter.filters })
    );
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Box sx={{ p: 1.5, pt: 0 }}>
        <Grid container spacing={1}>
          {categories.map((filter) => {
            const isActive = activePredefinedFilter === filter.id;
            return (
              <Grid item xs={6} sm={4} md={3} lg={2} key={filter.id}>
                <Tooltip title={filter.description} placement="top">
                  <Chip
                    label={filter.label}
                    onClick={() => handleApplyPredefined(filter)}
                    variant={isActive ? "filled" : "outlined"}
                    color={isActive ? "primary" : "default"}
                    sx={{
                      width: "100%",
                      height: "auto",
                      minHeight: 32,
                      py: 0.5,
                      justifyContent: "flex-start",
                      "& .MuiChip-label": {
                        display: "block",
                        whiteSpace: "normal",
                        textAlign: "left",
                        fontSize: "0.8rem",
                      },
                      "& .MuiChip-icon": {
                        marginLeft: "8px",
                        marginRight: "-4px",
                      },
                    }}
                  />
                </Tooltip>
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </Box>
  );
};

export default FilterShortcuts;
